import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BalanceQuery, config, MemberCard, MemberCardQuery, MemberDetails, MemberQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';

@Component({
  selector: 'fgb-mobile-page-header',
  templateUrl: './mobile-page-header.component.html',
  styleUrls: ['./mobile-page-header.component.scss'],
})
export class MobilePageHeaderComponent implements OnInit {
  @Input() showAfter: boolean = true;
  @Input() backButtonLink?: string;
  @Input() pageTitle: string;
  @Input() isHomePage: boolean = false;
  @Input() showBalance: boolean = true;
  @Input() showQr: boolean = true;

  screenType = ScreenType;
  memberCard$: Observable<MemberCard | undefined>;
  ecash$: Observable<number | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  member$: Observable<MemberDetails | undefined>;
  pointsBalance$: Observable<number | undefined>;

  constructor(
    private memberCardQuery: MemberCardQuery,
    private memberQuery: MemberQuery,
    private balanceQuery: BalanceQuery,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit() {
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.ecash$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
  }

  goBack() {
    if (this.backButtonLink) {
      this.router.navigate([this.backButtonLink]);
    } else {
      this.location.back();
    }
  }
}
